/* eslint-disable import/prefer-default-export */
export const API_GOOGLE_MAPS = 'API_GOOGLE_MAPS';
export const API_GOOGLE_CHARTS = 'API_GOOGLE_CHARTS';
export const API_GOOGLE_GEOLOCATION = 'API_GOOGLE_GEOLOCATION';
export const POSTCODE_IO = 'POSTCODE_IO';
